import { useEffect } from 'react';
import { toast } from 'react-hot-toast';

import { pickBy } from 'es-toolkit';

export enum ToastStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface ToastData {
  status: ToastStatus;
  title?: string;
  message: string;
  id?: string;
}

const useToast = (data?: ToastData, onSuccess?: () => void) => {
  useEffect(() => {
    if (data) {
      const { status, title, message, id } = data;
      const toastMessage = `${title ? `${title}\n` : ''}${message}`;
      const toastOptions = pickBy({ id }, (value) => value !== undefined);

      if (status === ToastStatus.ERROR) {
        toast.error(toastMessage, toastOptions);
      } else {
        toast.success(toastMessage, toastOptions);
        if (onSuccess) {
          onSuccess();
        }
      }
    }
  }, [data]);
};

export default useToast;
